<form [formGroup]="form">
  <div class="row">
    <div class="col form-group mb-0">
      <label for="organizationName" class="control-label">Organization name</label>
    </div>

    <div class="col form-group mb-0">
      <label for="industry" class="control-label">Industry</label>
    </div>
  </div>

  <div class="row">
    <div class="col form-group">
      <input
        id="organizationName"
        type="text"
        class="form-control"
        placeholder="Enter organization name"
        formControlName="name"
        [class.is-invalid]="form.get('name').touched && form.get('name').invalid"
      />
      <control-messages [control]="form.get('name')"></control-messages>
    </div>

    <div class="col form-group">
      <frontend-dropdown-plain
        id="industry"
        elementId="industry"
        formControlName="industry"
        customClass="text-nowrap"
        [class.is-invalid]="form.get('industry').touched && form.get('industry').invalid"
        [items]="industries"
      ></frontend-dropdown-plain>
      <control-messages [control]="form.get('industry')"></control-messages>
    </div>
  </div>

  <div class="info-message">
    <tr-icon [icon]="icon.infoHeavy" [size]="size.small"></tr-icon>
    <p>Define the default value for website URLs for new locations. If the checkbox is checked, the value is copied to all existing locations after saving.</p>
  </div>

  <div class="row">
    <div class="col form-group mb-0">
      <label for="websiteUrl" class="control-label">Website URL</label>
    </div>
  </div>

  <div class="row">
    <div class="col form-group">
      <input
        id="websiteUrl"
        type="text"
        class="form-control"
        placeholder="http:// or https://"
        formControlName="websiteUrl"
        [class.is-invalid]="form.get('websiteUrl').touched && form.get('websiteUrl').invalid"
      />
      <control-messages [control]="form.get('websiteUrl')"></control-messages>

      <label class="form-check-label apply-all">
        <input
          type="checkbox"
          class="form-check-input"
          formControlName="applyWebsiteToAll">Apply the website URL to all locations
      </label>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col form-group">
      <button
        class="btn btn-info w-100"
        [style.min-width]="'110px'"
        [disabled]="submitting || form.invalid || !form.dirty"
        (click)="submit()"
      >Save changes</button>
    </div>

    <div class="col form-group">
      <button class="btn btn-danger w-100" (click)="reset()">Cancel</button>
    </div>
  </div>
</form>
